import Vue from 'vue';
import VueRouter from 'vue-router';

export default class QuerystringManager {
	constructor() {
		Vue.use(VueRouter)
		this._vue = new Vue({
			router: new VueRouter({
				mode: 'history'
			})
		});
		this.router = this._vue.$router;
		this.route = this._vue.$route;
	}

	getRoute() { // work around for a reactivity issue
		return this._vue.$route;
	}

	addQueryParam(key, value) {
		if (!key || !value) return;

		const params = new URLSearchParams(window.location.search);
		params.set(key, value);

		this._vue.$router.replace({
			query: Object.fromEntries(params.entries()),
			hash: window.location.hash
		}).catch(err => {
			if (
				err.name !== 'NavigationDuplicated' &&
				!err.message.includes('Avoided redundant navigation to current location')
			) {
				console.error(err);
			}
		});
	}

	removeQueryParam(key) {
		const params = new URLSearchParams(window.location.search);
		params.delete(key);

		this._vue.$router.replace({
			query: Object.fromEntries(params.entries()),
			hash: window.location.hash
		}).catch(err => {
			if (
				err.name !== 'NavigationDuplicated' &&
				!err.message.includes('Avoided redundant navigation to current location')
			) {
				console.error(err);
			}
		});
	}
}